import { useContext } from "react";
import PropTypes from "prop-types";

import { removeCharacterEntities } from "../../helpers/formatters";
import { CompanyContext } from "../CompanyList/CompanyContext";

export const BaseBenefitsColumns = ({ classNames }) => {
	const { company } = useContext(CompanyContext);

	const splitBenefitsArray = (benefitsArray) => {
		// eslint-disable-next-line no-magic-numbers
		const middle = Math.ceil(benefitsArray.length / 2);
		const firstHalf = benefitsArray.slice(0, middle);
		const secondHalf = benefitsArray.slice(middle);
		return [firstHalf, secondHalf];
	};

	const benefitsArray = company?.fields?.companyMainBenefits || [];
	const formattedBenefitsList = removeCharacterEntities(benefitsArray);

	const [firstHalf, secondHalf] = splitBenefitsArray(formattedBenefitsList);

	const BenefitsList = ({ benefits, prefix }) => (
		<ul className={classNames?.list}>
			{benefits.map((benefit, idx) => (
				<li key={`${prefix}-${idx}`} className={classNames?.listItem}>
					{benefit}
				</li>
			))}
		</ul>
	);

	BenefitsList.propTypes = {
		benefits: PropTypes.arrayOf(PropTypes.string).isRequired,
		prefix: PropTypes.string.isRequired,
	};

	return (
		<div className={classNames?.wrapper}>
			{/* Desktop */}
			<div className="tw-hidden tw-gap-4 lg:tw-flex">
				<BenefitsList benefits={firstHalf} prefix="first" />
				<BenefitsList benefits={secondHalf} prefix="second" />
			</div>

			{/* Mobile */}
			<div className="tw-block lg:tw-hidden">
				<BenefitsList benefits={formattedBenefitsList} prefix="mobile" />
			</div>
		</div>
	);
};

BaseBenefitsColumns.propTypes = {
	classNames: PropTypes.shape({
		wrapper: PropTypes.string,
		list: PropTypes.string,
		listItem: PropTypes.string,
	}),
};
